import { render, staticRenderFns } from "./TokenList.vue?vue&type=template&id=f6e12134&scoped=true&"
import script from "./TokenList.vue?vue&type=script&lang=js&"
export * from "./TokenList.vue?vue&type=script&lang=js&"
import style0 from "./TokenList.vue?vue&type=style&index=0&id=f6e12134&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6e12134",
  null
  
)

export default component.exports